<template>
  <v-app id="bolsa-familia-criancas-mulheres" class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :item-class="getRowColor"
          :search="search"
          item-key="index"
          class="elevation-1"
          show-expand
          :single-expand="true"
          :expanded.sync="expanded"
        >
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{ formatDate(item.dt_nascimento) }}
          </template>

          <template v-slot:item.ult_acomp="{ item }">
            {{
              camposExibicao(item).ult_acomp
                ? formatDate(camposExibicao(item).ult_acomp)
                : ''
            }}
          </template>

          <template v-slot:item.peso="{ item }">
            {{ camposExibicao(item).peso }}
          </template>

          <template v-slot:item.altura="{ item }">
            {{ camposExibicao(item).altura }}
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <table class="table table-interna mt-3">
                <thead>
                  <tr>
                    <th>NIS</th>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>Endereço</th>
                    <th>Saiu?</th>
                    <th>Microárea</th>
                    <th>Cadastrado por</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.nis }}</td>
                    <td>{{ item.nu_cpf }}</td>
                    <td>{{ item.nu_cns }}</td>
                    <td>{{ item.endereco }}</td>
                    <td>{{ item.saiu == 1 ? 'Sim' : 'Não' }}</td>
                    <td>{{ item.micro_area }}</td>
                    <td>{{ item.no_profissional }}</td>
                  </tr>
                </tbody>
              </table>

              <table class="table table-interna table-ocorrencias mt-3">
                <thead>
                  <tr>
                    <th>
                      <div class="d-flex align-items-center">
                        <span>Ocorrências</span>
                        <button
                          type="button"
                          class="btn-ocorrencia ml-2"
                          :title="
                            temOcorrencia(item)
                              ? 'Editar ocorrência'
                              : 'Adicionar ocorrência'
                          "
                          @click="abrirModalOcorrencia(item)"
                        >
                          <i
                            :class="
                              temOcorrencia(item)
                                ? 'icofont-pencil'
                                : 'icofont-plus'
                            "
                          ></i>
                        </button>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!listaOcorrencias(item).length">
                    <td class="ocorrencia-texto"></td>
                  </tr>
                  <tr
                    v-for="(ocorrencia, idx) in listaOcorrencias(item)"
                    :key="`${item.index}-ocorrencia-${idx}`"
                  >
                    <td class="ocorrencia-texto">
                      {{ formatarOcorrenciaExibicao(ocorrencia) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>

          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>

          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>

          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <b-modal
      id="modal-ocorrencia-criancas-mulheres"
      v-model="modalOcorrencia.show"
      centered
      size="lg"
      hide-footer
      @hidden="fecharModalOcorrencia"
    >
      <template #modal-title>
        {{
          temOcorrencia(modalOcorrencia.item)
            ? 'Editar ocorrência'
            : 'Adicionar ocorrência'
        }}
      </template>

      <div class="form-group mb-3">
        <label>Motivo / Ocorrência</label>
        <vue-select
          v-model="modalOcorrencia.motivo"
          class="select-motivo-ocorrencia"
          :options="opcoesMotivos"
          label="label"
          :reduce="(option) => option"
          :clearable="false"
          :disabled="modalOcorrencia.loading"
          placeholder="Selecione o motivo"
        >
          <template #option="{ id, ds }">
            {{ id }} - {{ ds }}
          </template>
          <template #selected-option="{ id, ds }">
            {{ id }} - {{ ds }}
          </template>
          <template #no-options>
            Não há opções correspondentes
          </template>
        </vue-select>
      </div>

      <div class="d-flex justify-content-end">
        <b-button
          variant="outline-primary"
          class="mr-2"
          :disabled="modalOcorrencia.loading"
          @click="fecharModalOcorrencia"
        >
          Cancelar
        </b-button>
        <b-button
          variant="primary"
          :disabled="modalOcorrencia.loading || !modalOcorrencia.motivo"
          @click="salvarOcorrencia"
        >
          Salvar
          <b-spinner
            v-if="modalOcorrencia.loading"
            small
            class="ml-1"
          ></b-spinner>
        </b-button>
      </div>
    </b-modal>
  </v-app>
</template>

<script>
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import utils from '@/mixins/utils.js'
import * as Functions from './functions.js'
import {
  motivosOcorrencia,
  montarOcorrencia,
  montarPayloadOcorrencia,
  formatarOcorrenciaExibicao,
  temOcorrencia,
  normalizarOcorrencia,
  normalizarListaOcorrencias,
} from './ocorrencias.js'

export default {
  name: 'TabelaCadastros',
  components: {
    VueSelect,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    usarDadosMs: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      search: '',
      modalOcorrencia: {
        show: false,
        loading: false,
        item: null,
        motivo: null,
      },
      headers: [
        {
          text: 'NOME',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'NASCIMENTO',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'MÃE',
          align: 'start',
          filterable: true,
          value: 'no_mae',
        },
        {
          text: 'ACOMPANHADO',
          align: 'start',
          filterable: false,
          value: 'ult_acomp',
        },
        {
          text: 'PESO',
          align: 'start',
          filterable: false,
          value: 'peso',
        },
        {
          text: 'ALTURA',
          align: 'start',
          filterable: false,
          value: 'altura',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        index,
        ...item,
      }))
    },
    opcoesMotivos() {
      return motivosOcorrencia.map((motivo) => ({
        ...motivo,
        label: `${motivo.id} - ${motivo.ds}`,
      }))
    },
  },
  watch: {
    cadastros: {
      handler() {
        this.currentPage = 1
        this.expanded = []
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
    },
  },
  methods: {
    temOcorrencia,
    formatarOcorrenciaExibicao,

    /**
     * Campos de acompanhamento/peso/altura conforme o filtro ativo.
     *
     * @param {Object} item
     * @returns {{ ult_acomp: *, peso: *, altura: * }}
     */
    camposExibicao(item) {
      return Functions.getCamposExibicao(item, this.usarDadosMs)
    },

    /**
     * Lista normalizada de ocorrências do cadastro (array, objeto ou JSON string).
     *
     * @param {Object} item
     * @returns {Array}
     */
    listaOcorrencias(item) {
      return normalizarListaOcorrencias(item?.ocorrencia)
    },

    /**
     * Abre o modal para adicionar ou editar a ocorrência.
     *
     * @param {Object} item
     */
    abrirModalOcorrencia(item) {
      const ocorrencia = normalizarOcorrencia(item?.ocorrencia)
      let motivo = null

      if (ocorrencia?.id) {
        motivo =
          this.opcoesMotivos.find((opcao) => opcao.id === ocorrencia.id) ||
          null
      }

      this.modalOcorrencia = {
        show: true,
        loading: false,
        item,
        motivo,
      }
    },

    /**
     * Fecha e limpa o modal de ocorrência.
     */
    fecharModalOcorrencia() {
      this.modalOcorrencia = {
        show: false,
        loading: false,
        item: null,
        motivo: null,
      }
    },

    /**
     * Salva a ocorrência via API e atualiza o item na tabela.
     */
    async salvarOcorrencia() {
      if (!this.modalOcorrencia.item || !this.modalOcorrencia.motivo) {
        return
      }

      const item = this.modalOcorrencia.item
      const ocorrencia = montarOcorrencia(
        this.modalOcorrencia.motivo,
        this.$store.state.username
      )
      const payload = montarPayloadOcorrencia(item.nis, [ocorrencia])

      try {
        this.modalOcorrencia.loading = true

        await Functions.salvarOcorrencia(this.$store.state.cod_ibge, payload)

        this.$set(item, 'ocorrencia', payload.ocorrencia)

        const original = this.cadastros[item.index]
        if (original) {
          this.$set(original, 'ocorrencia', payload.ocorrencia)
        }

        this.$toast.success('Ocorrência salva com sucesso!', 'Sucesso:', {
          position: 'topRight',
        })
        this.fecharModalOcorrencia()
      } catch (error) {
        console.log(error)
        this.$toast.error('Erro ao salvar ocorrência!', 'Erro:', {
          position: 'topRight',
        })
      } finally {
        this.modalOcorrencia.loading = false
      }
    },

    /**
     * Filtra os registros da tabela com base no texto de busca.
     *
     * @param {String} search
     * @returns {Array}
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      return this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value] ?? '').toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
    },

    /**
     * Retorna a classe CSS da linha conforme o acompanhamento.
     *
     * @param {Object} item
     * @returns {string}
     */
    getRowColor(item) {
      return `table-row-color-${Functions.printTableRow(item)}`
    },

    /**
     * Atualiza a página atual da tabela.
     *
     * @param {Object} options
     */
    getPagination(options) {
      this.currentPage = options.page
    },
  },
}
</script>

<style lang="scss">
#bolsa-familia-criancas-mulheres {
  .table-interna {
    width: 100%;
    margin: 25px auto;
    display: table;

    thead tr {
      background-color: #f7f7f7;
    }
  }

  .table-ocorrencias {
    .ocorrencia-texto {
      white-space: pre-wrap;
      min-height: 40px;
      vertical-align: top;
    }
  }

  .btn-ocorrencia {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid transparent;
    border-radius: 32px;
    background-color: #0fafd7;
    color: #fff;
    padding: 0;
    line-height: 1;
    cursor: pointer;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
      0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);

    i {
      font-size: 16px;
      color: #fff;
    }

    &:hover {
      background-color: #0d9bc0;
      opacity: 1;
    }

    &:active {
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.14);
      transform: translateY(1px);
    }
  }
}

.select-motivo-ocorrencia {
  .vs__dropdown-toggle {
    height: auto;
    min-height: 45px;
    align-items: flex-start;
  }

  .vs__selected-options {
    flex-wrap: wrap;
  }

  .vs__selected {
    white-space: normal;
    word-break: break-word;
    line-height: 1.35;
    height: auto;
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .vs__dropdown-menu {
    min-width: 100%;
    width: max-content;
    max-width: min(90vw, 720px);
  }

  .vs__dropdown-option {
    white-space: normal;
    word-break: break-word;
    line-height: 1.4;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
